<template>
  <div class="app-card">
    <div v-if="$slots.header" class="app-card__header">
      <slot name="header" />
    </div>

    <slot />

    <div v-if="$slots.footer" class="app-card__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<style lang="scss">
// :where() keeps these at zero specificity so utility classes and scoped styles win
:where(.app-card) {
  background-color: $color-surface;
  border: 1px solid $color-border;
  border-radius: 12px;
  box-shadow:
    0 1px 2px rgba($color-ink, 0.04),
    0 16px 40px -16px rgba($color-ink, 0.2);
}

:where(.app-card__header) {
  margin-bottom: 20px;
}

:where(.app-card__footer) {
  margin-top: 20px;
}
</style>
